const appConfig = require('appConfig');


export const getUserManagerSettings = () => {
  return appConfig.userManager;
};

export const getCannedMessageEndpoint = () => {
  return appConfig.expertApiUrl;
}; 

export const mixpanelToken = (appConfig.mixpanel && appConfig.mixpanel.token) || '';




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/configs/index.ts